<template>
    <div>
        <Desktop
            @change-profile="$emit('change-profile')"
            @push-route="pushRoute"
            v-if="!isMobile"
        />
        <Mobile
            @change-profile="$emit('change-profile')"
            @push-route="pushRoute"
            :show="show"
            @show="showAction"
            v-else
        />
    </div>
</template>

<script>
import Desktop from '@/layouts/header/contractor/guest/desktop.vue';
import Mobile from '@/layouts/header/contractor/guest/mobile.vue';
export default {
    components: { Mobile, Desktop },
    name: 'HeaderGuestContractor',
    data () {
        return {
            isMobile: '',
            show: false
        };
    },
    methods: {
        showAction () {
            this.show = !this.show;
            this.$emit('show', this.show);
        },
        pushRoute (objectUrl) {
            if (objectUrl.solo) {
                window.open(objectUrl.url, '_blank');
            } else if (objectUrl.url && this.$route.name != objectUrl.url) {
                this.$router.push({ name: objectUrl.url });
            }
            this.show = false;
            this.$emit('show', this.show);
        }
    },
    mounted () {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 1280;
        });
        vue.isMobile = window.innerWidth <= 1280;
    }
};
</script>
